export function typeWriter(elemento, htmlTexto, velocidad, funcion) {
    const contenedor = document.createElement('div');
    contenedor.innerHTML = htmlTexto;

    const nodos = Array.from(contenedor.childNodes);
    let indexNodo = 0;

    function escribirNodo() {
        if (indexNodo >= nodos.length) {
            setTimeout(funcion, 500);
            return;
        }

        const nodo = nodos[indexNodo];
        indexNodo++;

        if (nodo.nodeType === Node.TEXT_NODE) {
            escribirTextoNodo(nodo, 0, () => {
                escribirNodo();
            });
        } else if (nodo.nodeType === Node.ELEMENT_NODE) {
            const nuevoElemento = nodo.cloneNode(false);
            elemento.appendChild(nuevoElemento);
            const contenido = nodo.innerHTML;

            typeWriter(nuevoElemento, contenido, velocidad, escribirNodo);
        }
    }

    function escribirTextoNodo(nodo, i, callback) {
        const texto = nodo.textContent;
        if (i < texto.length) {
            const char = texto.charAt(i);
            elemento.innerHTML += char;
            let delay = velocidad;
            if (char === '.' || char === ',') {
                delay += 500;
            }
            setTimeout(() => escribirTextoNodo(nodo, i + 1, callback), delay);
        } else {
            callback();
        }
    }

    escribirNodo();
}